import React from 'react';
import Link from "next/link";
import { useRouter } from 'next/router';
export const AnchorLink = ({
  children,
  href
}) => {
  const router = useRouter();
  return <Link href={href} style={{
    display: "block",
    textDecoration: "none",
    color: "inherit",
    width: "100%"
  }} rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-component="AnchorLink" data-sentry-source-file="AnchorLink.jsx">
      {children}
    </Link>;
};